export default __webpack_public_path__ + "static/media/May_06.dfe30652.png";